class postJobController {
  constructor(UsersService, NotificationService) {
    'ngInject';
    this.usersService = UsersService;
    this.notificationService = NotificationService;
    this.jobCountOptions = [50, 100, 150];
    this.selectedJobCount = null;
    this.manualJobCount = null;
    this.isLoading = false;
  }

  addJobs() {
    const count = this.selectedJobCount === 'manual' ? this.manualJobCount : this.selectedJobCount;
    if (!count || count <= 0) return;

    this.isLoading = true;
    this.usersService.updateJobPostLimit(this.user.userId, count,
      (response) => {
        this.user.clientInfo.jobPostLimit = response.data;
        this.selectedJobCount = null;
        this.manualJobCount = null;
        this.isLoading = false;
        this.notificationService.success('Job post limit updated successfully.');
      },
      (error) => {
        this.isLoading = false;
        this.notificationService.error('Failed to update job post limit.');
      }
    );
  }
}

export default postJobController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/post-job/post-job.controller.js
 **/